export const extractOptionId = (option) => {
  if (!option) return null;

  const candidates = [
    option?.value,
    option?.Id,
    option?.id,
    option?.IdVeiculo,
    option?.idVeiculo,
    option?.data?.value,
    option?.data?.Id,
    option?.data?.id,
    option?.data?.IdVeiculo,
    option?.data?.idVeiculo,
  ];

  const found = candidates.find(
    (candidate) => candidate !== undefined && candidate !== null && candidate !== ""
  );

  return found !== undefined ? found : null;
};

export const normalizeOptionValue = (option) => {
  const extracted = extractOptionId(option);
  if (extracted === null) return null;
  return String(extracted);
};

export const formatVeiculoOption = (veiculo) => {
  if (!veiculo) return null;
  const parts = [veiculo?.Frota, veiculo?.Placa].filter(Boolean);
  const fallback = `Veiculo ${veiculo?.Id ?? ""}`.trim();
  const label = (parts?.length ?? 0) > 0 ? parts.join(" - ") : fallback;
  return { value: veiculo?.Id, label, data: veiculo };
};
